import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  LocationWrapper,
  IconContainer,
  LocationText,
  DistanceFromUser,
} from './VehicleCard.styles';
import PoiMarker from '../../assets/icons/PoiMarker';
import DealerName from '../DealerName';
import getParsedNumber from '../../utils/getParsedNumber';

interface ILocationProps {
  isNewVehicle: boolean;
  dealerName: string;
  distanceFromUser: number;
  unitOfMeasurement: string;
  noFixHeight?: boolean;
}

const Location: React.FC<ILocationProps> = ({
  isNewVehicle,
  dealerName,
  distanceFromUser,
  unitOfMeasurement,
  noFixHeight,
}) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.languages?.[0] || 'en';

  const formattedDistanceFromUser = getParsedNumber(distanceFromUser, lang);

  return (
    <>
      <LocationWrapper isNewVehicle={isNewVehicle} noFixHeight={noFixHeight || false}>
        <IconContainer>
          <PoiMarker />
        </IconContainer>
        <LocationText>
          <DealerName
            name={dealerName}
            data-testid="dealer-name"
            data-cy="vehicle-card-dealer-name"
          />
        </LocationText>
        {distanceFromUser > 0 && (
          <DistanceFromUser
            data-testid="dealers-distance-from-user"
            data-cy="vehicle-card-deistance-from-user"
          >
            {t('vlp.vehicleResults.vehicleCard.distanceFromUser', {
              distanceFromUser: formattedDistanceFromUser,
              unitOfMeasurement,
            })}
          </DistanceFromUser>
        )}
      </LocationWrapper>
    </>
  );
};

export default Location;
